import { useState, useEffect } from "react";

const useSubmitForm = (initialFormValues, callback, validate) => {
  const [inputs, setInputs] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors]);

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };
  const uploadedFileUrl = (url) => {
    console.log("🚀 ~ file: useSubmitForm.js ~ line 19 ~ uploadedFileUrl ~ url", url);
    setInputs((inputs) => ({ ...inputs, img_url: url }));
  };

  const clearForm = () => {
    setInputs(initialFormValues);
  };

  const handlePreview = (event) => {
    if (event) event.preventDefault();
    const errors = validate(inputs);
    setErrors(errors);
    return Object.keys(errors).length > 0;
    // setIsSubmitting(true);
  };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(inputs));
    setIsSubmitting(true);
  };

  return {
    handleInputChange,
    uploadedFileUrl,
    handlePreview,
    handleSubmit,
    inputs,
    clearForm,
    errors,
  };
};

export default useSubmitForm;
